export default class WorkflowColaborador {

  constructor(
    IdWorkflow = null,
    IdColaborador = null,
    Colaborador = ''
  ) {
    this.IdWorkflow = IdWorkflow;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
  }
  
}